export const SessionsService = {
  isAuthorized(): boolean {
    return Boolean(localStorage.getItem('data') || localStorage.getItem('transactionDetails'));
  },
  isAuthorizedToSuccessPage(): boolean {
    return Boolean(localStorage.getItem('transactionDetails'));
  },
};
